<template>

	<div class="fc">

		<div>
			<p>Como está a saúde do seu consultório ou clínica?</p>
			<p>A rotina costuma ser corrida em consultórios e clínicas e a falta de tempo acaba adiando um momento importantíssimo, que é parar um pouco para pensar no seu consultório ou clínica como um negócio e fazer uma avaliação e reflexão com o objetivo de identificar em que momento o seu negócio está.</p>
			<p>O diagnóstico gerencial é uma ferramenta que, além de servir como referência na tomada de decisões importantes para o crescimento e expansão do negócio, é imprescindível para a sobrevivência de consultórios e clínicas, pois a sua realização permite identificar pontos fortes e também problemas graves na gestão do negócio, assim como identificar oportunidades de melhorias, possibilitando que sejam feitos ajustes e correções.</p>
			<p>Faça gratuitamente a versão on-line resumida do diagnóstico gerencial e descubra se seu consultório ou clínica está saudável. </p>

			<br>
		</div>

		<button class="btn btn-success" @click="IniciarTeste">Iniciar teste</button>	
		
	</div>
	
</template>

<script>

export default {
	name: "BemVindo",
	methods: {
		IniciarTeste () {
			this.$parent.showDadosCadastrais();
			//this.$parent.showQuestionarios();
		}
	}
}
</script>

<style scoped>

</style>